import React from "react";
import { pdf } from "@react-pdf/renderer";
import WizardQuestionsPDF from "../components/WizardQuestionsPDF";

export const downloadWizardQuestionsPDF = async questionsData => {
  try {
    // Create the PDF document
    const blob = await pdf(
      <WizardQuestionsPDF questionsData={questionsData} />
    ).toBlob();

    // Create a download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "Wizard_Questions_Answers.pdf";

    // Trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error generating PDF:", error);
    throw error;
  }
};
